import axios from 'axios'
import jsonpAdapter from './jsonpAdapter'
import finalHandlers from '../finalHandlers/index'
const defaultAdapter = axios.defaults.adapter

export default function dajaxAdapter(config) {
  return finalHandlers(config).then((config) => {
    if (config.jsonp) {
      return jsonpAdapter(config)
    } else {
      return defaultAdapter(config)
    }
  })
}